export default __webpack_public_path__ + "static/media/category-book.4659449d.svg";